import {WishlistActions} from '@wix/wixstores-client-storefront-sdk/dist/es/src/actions/WishlistActions/WishlistActions';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/site-store/SiteStore';
import type {ReportError} from '../viewerScript/GalleryController';

export class WishlistService {
  private wishlistActions: WishlistActions | null = null;
  private userWishlistMap: Record<string, boolean> = {};

  constructor(private readonly siteStore: SiteStore, private readonly reportError: ReportError) {}

  public getUserWishlistMap(): Record<string, boolean> {
    return this.userWishlistMap;
  }

  public setProductWishlistState(productId: string, shouldAdd: boolean): void {
    if (shouldAdd) {
      this.userWishlistMap[productId] = true;
    } else {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.userWishlistMap[productId];
    }
  }

  public async fetchUserWishlistMap(): Promise<void> {
    try {
      const response = await this.getWishlistActions().getWishlist();
      const items = response.wishlist?.items;
      const map: Record<string, boolean> = {};
      for (const item of items) {
        map[item.id] = true;
      }
      this.userWishlistMap = map;
    } catch (e) {
      this.userWishlistMap = {};
      this.reportError(e);
    }
  }

  public async addProduct(productId: string): Promise<void> {
    await this.getWishlistActions().addProducts([productId]);
  }

  public async removeProduct(productId: string): Promise<void> {
    await this.getWishlistActions().removeProducts([productId]);
  }

  private getWishlistActions(): WishlistActions {
    if (!this.wishlistActions) {
      this.wishlistActions = new WishlistActions(this.getHeaders());
    }
    return this.wishlistActions;
  }

  private getHeaders() {
    return {
      Authorization: (this.siteStore.httpClient.getBaseHeaders() as any).Authorization,
    };
  }
}
